import React from 'react';

/** "Call" button that only reveals the photographer's number as plain text.
 * It deliberately is not a tel: link — on a Mac that opens FaceTime, and the
 * admin only wants to read the number. Click again to hide it. */
const CallButton: React.FC<{ contact?: string | null }> = ({ contact }) => {
    const [shown, setShown] = React.useState(false);
    if (!contact) return null;
    return (
        <button
            type="button"
            onClick={(e) => { e.stopPropagation(); setShown((s) => !s); }}
            title={shown ? 'Click to hide' : 'Show phone number'}
            style={{
                flexShrink: 0, display: 'inline-flex', alignItems: 'center', gap: 5, border: '1px solid rgba(255,255,255,0.15)',
                background: 'rgba(255,255,255,0.03)', color: 'inherit', fontWeight: 700, fontSize: 11, padding: '6px 11px',
                borderRadius: 8, cursor: 'pointer',
            }}
        >
            <i className="mdi mdi-phone-outline" />
            {shown ? <span style={{ userSelect: 'text', letterSpacing: 0.2 }}>{contact}</span> : 'Call'}
        </button>
    );
};

export default CallButton;
